<template>
  <ListingBlock
    class="books-block"
    :view="view"
    :docs="view.docs().filteredDocs.slice(0, 4)"
    :cardProps="{ showFreeBooks }"
    :docViewEventProperties="docViewEventProperties"
  />
</template>

<script setup lang="ts">
import ListingBlock from '@/app/components/listing/ListingBlock.vue'

import type { ListView } from '@/models/docs.list'
import type { ListItem } from '@/models/interfaces'

withDefaults(
  defineProps<{
    view: ListView
    showFreeBooks?: boolean
    docViewEventProperties?: (doc: ListItem) => Record<string, unknown>
  }>(),
  {
    showFreeBooks: true,
  },
)
</script>

<style lang="scss" scoped>
.books-block {
  --listing-block-number-of-columns: 4;
  --listing-block-items-width-mobile: 220px;
}
</style>
